"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var redeemed = {
    default: function (_a) {
        var voucher = _a.voucher;
        return react_1.default.createElement(storybook_1.Texts.Badge, null, voucher.redeems);
    },
    'promo-code': function (_a) {
        var voucher = _a.voucher;
        return react_1.default.createElement(storybook_1.Texts.Badge, null,
            voucher.redeems,
            "/",
            voucher.limit);
    },
    vip: function (_a) {
        var voucher = _a.voucher;
        return react_1.default.createElement(storybook_1.Texts.Badge, null,
            voucher.redeems,
            "/",
            voucher.invites);
    }
};
var Card = function (_a) {
    var voucher = _a.voucher, onDelete = _a.onDelete, onShare = _a.onShare, user = _a.user;
    var Redeemed = redeemed[voucher.type] || redeemed.default;
    return react_1.default.createElement(storybook_1.Cards.Card, null,
        react_1.default.createElement("div", { className: 'storybook-vouchers-card-circle-mask storybook-vouchers-card-circle-mask-tl' }),
        react_1.default.createElement("div", { className: 'storybook-vouchers-card-circle-mask storybook-vouchers-card-circle-mask-tr' }),
        react_1.default.createElement("div", { className: 'storybook-vouchers-card-circle-mask storybook-vouchers-card-circle-mask-br' }),
        react_1.default.createElement("div", { className: 'storybook-vouchers-card-circle-mask storybook-vouchers-card-circle-mask-bl' }),
        react_1.default.createElement(storybook_1.Cards.Content, null,
            react_1.default.createElement("div", { className: 'flex justify-between item-center' },
                react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h4' }, voucher.name),
                react_1.default.createElement("div", { className: 'flex items-center space-x-3' },
                    react_1.default.createElement(Redeemed, { voucher: voucher }),
                    user.permissions.includes('ecommerce.vouchers.destroy') &&
                        react_1.default.createElement(storybook_1.Buttons.Button, { onClick: function () { return onDelete(voucher); } },
                            react_1.default.createElement(storybook_1.Icons.Icon, { name: 'trash', className: 'storybook-icons-icon text-disabled' })))),
            react_1.default.createElement(storybook_1.Texts.Secondary, null,
                voucher.start,
                " / ",
                voucher.end),
            react_1.default.createElement(storybook_1.Texts.Secondary, null, voucher.type_label)),
        react_1.default.createElement(storybook_1.Cards.Buttons, null,
            user.permissions.includes('ecommerce.vouchers.update') &&
                react_1.default.createElement(storybook_1.Cards.Button, { href: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/vouchers/" + voucher.id + "/edit" },
                    react_1.default.createElement(storybook_1.Icons.Icon, { name: 'pencil', className: 'storybook-icons-icon' }),
                    " Bewerken"),
            voucher.type !== 'vip' &&
                react_1.default.createElement(storybook_1.Cards.Button, { onClick: onShare },
                    react_1.default.createElement(storybook_1.Icons.Icon, { name: 'share', className: 'storybook-icons-icon' }),
                    " Delen"),
            voucher.type === 'vip' &&
                react_1.default.createElement(storybook_1.Cards.Button, { href: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/vouchers/" + voucher.id + "/emails" },
                    react_1.default.createElement(storybook_1.Icons.Icon, { name: 'mail', className: 'storybook-icons-icon' }),
                    " Delen")));
};
exports.Card = Card;
exports.Card.propTypes = {
    voucher: prop_types_1.default.object
};
